import { render, staticRenderFns } from "./NewsDetail.vue?vue&type=template&id=65e40ddb&scoped=true&"
import script from "./NewsDetail.vue?vue&type=script&lang=js&"
export * from "./NewsDetail.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/newsDetail.css?vue&type=style&index=0&id=65e40ddb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e40ddb",
  null
  
)

export default component.exports